import easelAPI, { getOptions, postOptions, EaselResponse } from 'apis/helpers/easelAPI'

export { updateUserMeasurementUnit } from 'apis/private/user'

// To Deal with Akamai we need to fetch SESSION from CLIENTSIDE
export const fetchSession = async (): Promise<EaselResponse> => {
  const options = getOptions
  const json = await easelAPI.fetchJSON({
    name: 'fetchSession',
    options,
    url: '/session',
  })
  return json
}
